// The nav's views and the paths the pages live at. Every page is a route (router.tsx, nested: a page's children are
// the pages after it), so the URL path is the stack of open pages: /settings/instances/michael/members =
// Settings › Instances › michael › Members. Not routes: the nav (always first) and the two modals kept in ?params,
// the task detail (?id: a sheet on phones, it belongs to a card anywhere in the row) and the scope picker (?scope).

/** page: a kind view's own page (src/views: /files), its nav entry the view's */
export type View = "board" | "chats" | "graph" | "secrets" | "settings" | "page";
export const VIEWS = ["board", "chats", "graph", "secrets"] as const;
export const VIEW_PATH: Record<Exclude<View, "page">, string> = { board: "/", chats: "/chats", graph: "/graph", secrets: "/secrets", settings: "/settings" };

/** The nav's view for a path: its first segment (anything else the board, or a kind view's page). */
export const viewOf = (pathname: string, pages: readonly string[] = []): View => {
	const s = pathname.split("/")[1];
	if (pages.includes(`/${s}`)) return "page";
	return s === "chats" || s === "graph" || s === "secrets" || s === "settings" ? s : "board";
};
